import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("abilities")
export class Ability {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "type", length: 255, nullable: true })
  type: string | null;

  @Column("tinyint", { name: "status", default: () => "'1'" })
  status: number;
}
